// extracted by mini-css-extract-plugin
export default {"dialog":"MCbqA","center":"u_Wd2","tabsContainer":"scip_","editButton":"E9DLB"};